import React from "react";
import { useAuth } from "../lib/auth";
import { ShieldAlert, LogOut } from "lucide-react";

export default function AdminImpersonationBanner() {
  const { user, exitImpersonation } = useAuth();
  if (!user?.impersonated_by) return null;
  return (
    <div
      data-testid="admin-impersonation-banner"
      className="sticky top-0 z-40 bg-amber-500 text-slate-900 border-b border-amber-600"
    >
      <div className="max-w-[1400px] mx-auto px-4 py-2.5 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 font-semibold">
          <ShieldAlert className="w-4 h-4" />
          ADMIN MODE — viewing as <span className="font-bold">{user.shop_name}</span>
          <span className="hidden sm:inline text-amber-900/80 font-normal">
            · Every action you take is being logged.
          </span>
        </div>
        <button
          data-testid="admin-exit-impersonation"
          onClick={exitImpersonation}
          className="inline-flex items-center gap-1.5 rounded-md bg-slate-900 text-amber-300 px-3 py-1.5 text-xs font-bold hover:bg-slate-800"
        >
          <LogOut className="w-3.5 h-3.5" /> Exit admin mode
        </button>
      </div>
    </div>
  );
}
